// Re-export pattern library Modal components
export { Modal as BaseModal } from 'equa-patternlib'

// Equa-web specific modals
export * from './shared-modals'
export * from './signup-modal'

// Legacy modal (default export for backward compatibility)
import Modal from './modal'
export { Modal }
export default Modal
